import React from 'react';
import { Navigate, Route } from 'react-router-dom';

const MessageElectronSend = React.lazy(
  () => import('pages/teacherSide/messageElectron/MessageElectronSend/MessageElectronSend'),
);
const MessageElectronHistory = React.lazy(
  () =>
    import(
      'pages/teacherSide/messageElectron/MessageElectronHistory/MessageElectronHistory'
    ),
);
const MessageElectronContact = React.lazy(
  () =>
    import(
      'pages/teacherSide/messageElectron/MessageElectronContact/MessageElectronContact'
    ),
);
const MessageElectronSolApi = React.lazy(
  () =>
    import(
      'pages/teacherSide/messageElectron/MessageElectronSolApi/MessageElectronSolApi'
    ),
);

const RouterListElectron = (
  <Route path="/teacherSide/">
    <Route
      path="messageElectron"
      element={<Navigate to="/teacherSide/messageElectron/send" replace />}
    />
    <Route path="messageElectron/send" element={<MessageElectronSend />} />
    <Route path="messageElectron/history" element={<MessageElectronHistory />} />
    <Route path="messageElectron/contact" element={<MessageElectronContact />} />
    <Route path="messageElectron/solapi" element={<MessageElectronSolApi />} />
  </Route>
);

export default RouterListElectron;
